import { getGlobals } from "storyblok/api"
import { getTeamMemberPaths, getTeamMember } from "storyblok/teamMembers"
import Meta from "components/Meta"
import TeamMemberPageHeader from "components/Archive/TeamMemberPageHeader"
import DynamicComponent from "components/DynamicComponent"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"
import { getExcerpt } from "utilities/getExcerpt"

export default function Article({ story }) {
  return (
    <>
      <Meta
        info={{
          title: `${story?.content?.first_name} ${story?.content?.last_name} | ${story?.content?.job_title}`,
          description: getExcerpt(story?.content?.bio),
          og_image: story?.content?.image?.filename,
          twitter_image: story?.content?.image?.filename,
        }}
      />
      <StoryblokVisualEditor story={story?.content}>
        <main data-pagefind-body data-pagefind-sort="weight[data-weight]" data-weight="1">
          <TeamMemberPageHeader
            blok={{
              heading: `${story?.content?.first_name} ${story?.content?.last_name}`,
              subheading: story?.content?.job_title,
              content: story?.content?.bio,
              image: story?.content?.image,
              breadcrumbs: [
                { text: "Team Members", href: "/team-members" },
                { text: `${story?.content?.first_name} ${story?.content?.last_name}`, href: "/team-members" },
              ],
            }}
          />
          {story?.content?.body?.length
            ? story?.content?.body.map((blok) => <DynamicComponent blok={blok} key={blok._uid} />)
            : null}
        </main>
      </StoryblokVisualEditor>
    </>
  )
}

export async function getStaticProps({ params: { member }, preview = null }) {
  const globals = await getGlobals()
  const story = await getTeamMember(`team-members/${member}`, preview)

  return {
    props: {
      story: story ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getTeamMemberPaths(),
    fallback: false,
  }
}
